import React from "react";
import ReactDOM from "react-dom/client";
import "./css/index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { transitions, positions, Provider as AlertProvider } from "react-alert"; //https://www.npmjs.com/package/react-alert
import AlertTemplate from "react-alert-template-basic";
import { CookiesProvider } from "react-cookie";

// optional cofiguration
const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: "20px",
  // you can also just use 'scale'
  transition: transitions.SCALE
};

// React 18: ReactDOM.render was replaced by createRoot.
// Deliberately NOT wrapped in <React.StrictMode> — StrictMode double-invokes
// effects in development, which would double-subscribe the MQTT client.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AlertProvider template={AlertTemplate} {...options}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </AlertProvider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
